const axios = require("axios").default;
const qs = require("querystring");
const inFlightReads = new Map();
// GET is also used by legacy endpoints with side effects, so only coalesce these reads.
const sharedReadPaths = /\/(getProfile|gatherCustomerServiceMeta|credit-purchase\/products|credit-purchase\/queryPtStatusForUid)(?:\?|$)/;

function copyResponse(response) {
    if (!response) return response;
    return {...response, data: response.data && typeof response.data === 'object'
        ? JSON.parse(JSON.stringify(response.data)) : response.data};
}

export class Request {
    static async makeRequest(path, method, body, queryParams, auth) {
        const isGet = method.toLowerCase() === 'get';
        if (!isGet) inFlightReads.clear();
        const key = typeof window !== 'undefined' && isGet && auth && sharedReadPaths.test(path)
            ? JSON.stringify([path, queryParams, auth]) : null;
        if (key && inFlightReads.has(key)) return inFlightReads.get(key).then(copyResponse);
        const request = axios.request({
            headers: {
                Authorization: auth
            },
            method: method,
            timeout: 30000,
            url: path,
            params: queryParams,
            data: body
        }).catch(e => {
            return e.response;
        });
        if (!key) return request;
        inFlightReads.set(key, request);
        const clear = () => { if (inFlightReads.get(key) === request) inFlightReads.delete(key); };
        request.then(clear, clear);
        return request.then(copyResponse);
    }

    static async postForm(path, formData) {
        inFlightReads.clear();
        return axios.post(path, qs.stringify(formData), {
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            transformRequest: (data, headers) => {
                console.log(headers);
                delete headers.common["sec-fetch-mode"];
            }
        });
    }
}
